import React from "react"
import PropTypes from "prop-types"
import ReactInputMask from "react-input-mask"
import TextFieldInput from "../text-field-input"

const GenericMaskedInput = ({mask, value, onChange, disabled, ...rest}) => (
    <ReactInputMask mask={mask} value={value} onChange={onChange} maskChar="" disabled={disabled}>
        {(inputMaskProps) => (
            <TextFieldInput
                {...rest}
                value={value}
                onChange={onChange}
                {...inputMaskProps}
                InputLabelProps={rest.InputLabelProps}
            />
        )}
    </ReactInputMask>
)

GenericMaskedInput.propTypes = {
    mask: PropTypes.string.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
}

export default GenericMaskedInput
